import React,{useEffect,useRef,useState} from 'react';
import {SERVER_URL} from '../../constants/server-type';
import './galleryPhotoViewer.css';
import {VideoPlayer} from './GalleryVideo';

export function sharePhoto(file,link,nav=navigator){
  // Called synchronously by a user click: no fetch/await before navigator.share.
  if(typeof nav.share!=='function')return Promise.resolve('download');
  let filesSupported=false;
  try{filesSupported=typeof nav.canShare==='function' && nav.canShare({files:[file]});}catch(_){}
  return Promise.resolve(nav.share(filesSupported?{files:[file],title:file.type.startsWith('video/')?'EveryID video':'EveryID photo'}:{url:link,title:file.type.startsWith('video/')?'EveryID video':'EveryID photo'}));
}

export default function GalleryPhotoViewer(){
  const [photo,setPhoto]=useState(null),[message,setMessage]=useState('Loading photo…'),[sharing,setSharing]=useState(false);
  const busy=useRef(false);
  useEffect(()=>{
    let stopped=false,objectUrl,timer;
    const abort=new AbortController();
    document.body.classList.add('gallery-photo-fullscreen');
    const referrer=document.createElement('meta');referrer.name='referrer';referrer.content='no-referrer';document.head.appendChild(referrer);
    (async()=>{
      let token;try{token=decodeURIComponent(window.location.hash.slice(1));}catch(_){throw new Error('Invalid link');}
      if(!token || token.length>2048)throw new Error('Invalid link');
      const response=await fetch(`${SERVER_URL}/gallery/photo-share/read`,{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({token}),credentials:'omit',cache:'no-store',referrerPolicy:'no-referrer',signal:abort.signal});
      if(!response.ok){const details=await response.json().catch(()=>({}));throw Object.assign(new Error('Access unavailable'),{publicMessage:typeof details.message==='string'?details.message:null});}
      const expiry=Number(response.headers.get('X-Photo-Expires-At'));
      const blob=await response.blob();
      if(!Number.isFinite(expiry)||expiry<=Date.now()||!(blob.type.startsWith('image/')||['video/mp4','video/webm','video/quicktime'].includes(blob.type))||!blob.size||blob.size>(blob.type.startsWith('video/')?64:25)*1024*1024)throw new Error('Invalid photo');
      if(stopped)return;
      const ext={'image/jpeg':'jpg','image/png':'png','image/webp':'webp','image/gif':'gif','image/bmp':'bmp','video/mp4':'mp4','video/webm':'webm','video/quicktime':'mov'}[blob.type];
      if(!ext)throw new Error('Unsupported photo');
      const kind=blob.type.startsWith('video/')?'video':'photo';
      const file=new File([blob],`EveryID-${kind}.${ext}`,{type:blob.type});
      objectUrl=URL.createObjectURL(blob);
      setPhoto({url:objectUrl,file,expiresAt:expiry,kind});setMessage('');
      timer=setTimeout(()=>{URL.revokeObjectURL(objectUrl);setPhoto(null);setMessage('This media link has expired. Request a new QR code from the Gallery.');},expiry-Date.now());
    })().catch(error=>{if(!stopped)setMessage(error.publicMessage || 'Media unavailable. The link may be expired or downloads disabled. Request a new QR code from the Gallery.');});
    return()=>{stopped=true;abort.abort();clearTimeout(timer);if(objectUrl)URL.revokeObjectURL(objectUrl);referrer.remove();document.body.classList.remove('gallery-photo-fullscreen');};
  },[]);
  function share(){
    if(!photo||busy.current)return;
    if(photo.expiresAt<=Date.now()){setPhoto(null);setMessage('This media link has expired. Request a new QR code.');return;}
    busy.current=true;setSharing(true);setMessage('');
    try{
      sharePhoto(photo.file,window.location.href).then(result=>{
        if(result==='download')setMessage('Use Save Photo, then share it from Photos or Files.');
      }).catch(e=>{if(e?.name!=='AbortError')setMessage('Sharing is unavailable here. Use Save Photo, then share from Photos or Files.');})
        .finally(()=>{busy.current=false;setSharing(false);});
    }catch(e){busy.current=false;setSharing(false);if(e?.name!=='AbortError')setMessage('Use Save Photo, then share from Photos or Files.');}
  }
  function download(e){if(!photo||photo.expiresAt<=Date.now()){e.preventDefault();setPhoto(null);setMessage('This media link has expired. Request a new QR code.');}}
  const video=photo?.kind==='video';
  return <main className="gallery-photo-viewer">
    <header className="gallery-photo-brand"><span className="gallery-photo-mark" aria-hidden="true">e</span><span>EveryID</span></header>
    <section className="gallery-photo-card" aria-labelledby="gallery-photo-title">
      <h1 id="gallery-photo-title">Your {video?'video':'photo'} is ready!</h1>
      <p className="gallery-photo-support">Save your {video?'video':'photo'} or share it with friends and family.</p>
      {photo&&<>
        {video?<VideoPlayer src={photo.url}/>:<button className="gallery-photo-image" onClick={share} disabled={sharing} aria-label="Share this photo"><img src={photo.url} alt="Selected Gallery photograph"/></button>}
        <p className="gallery-photo-hint">{video?'Play Video, or share it below.':'Tap photo to share.'}</p>
        <div className="gallery-photo-actions">
          <button onClick={share} disabled={sharing}>{sharing?'Sharing?':video?'Share Video':'Share Photo'}</button>
          <a href={photo.url} download={photo.file.name} onClick={download}>{video?'Save Video':'Save Photo'}</a>
        </div>
        {typeof navigator.share!=='function'&&<p className="gallery-photo-fallback">Save the {video?'video':'photo'}, then share it from Photos or Files.</p>}
      </>}
      <p className="gallery-photo-status" role="status">{message}</p>
    </section>
    <footer>Shared with <strong>EveryID</strong></footer>
  </main>;
}
